export var TypeActionOngoingPurchaseInfo;
(function (TypeActionOngoingPurchaseInfo) {
    TypeActionOngoingPurchaseInfo["SelectCharacterHelp"] = "PurchaseInfo > SelectCharacterHelp";
    TypeActionOngoingPurchaseInfo["CloseCharacterHelp"] = "PurchaseInfo > CloseCharacterHelp";
    TypeActionOngoingPurchaseInfo["DeselectCharacterHelp"] = "PurchaseInfo > DeselectCharacterHelp";
    TypeActionOngoingPurchaseInfo["SelectSkipProcess"] = "PurchaseInfo > SelectSkipProcess";
    TypeActionOngoingPurchaseInfo["DeselectSkipProcess"] = "PurchaseInfo > DeselectSkipProcess";
    TypeActionOngoingPurchaseInfo["SelectPremium"] = "PurchaseInfo > SelectPremium";
    TypeActionOngoingPurchaseInfo["SelectStandard"] = "PurchaseInfo > SelectStandard";
    TypeActionOngoingPurchaseInfo["DeselectPremium"] = "PurchaseInfo > DeselectPremium";
    TypeActionOngoingPurchaseInfo["DeselectStandard"] = "PurchaseInfo > DeselectStandard";
    TypeActionOngoingPurchaseInfo["CloseAll"] = "PurchaseInfo > CloseAll";
})(TypeActionOngoingPurchaseInfo || (TypeActionOngoingPurchaseInfo = {}));
export var actionOngoingPurchasePremiumSelect = function (premiumInfo) { return ({
    premiumInfo: premiumInfo,
    type: TypeActionOngoingPurchaseInfo.SelectPremium,
}); };
export var actionOngoingPurchaseStandardSelect = function (standardInfo, updateInventoryAfterPurchase) {
    if (updateInventoryAfterPurchase === void 0) { updateInventoryAfterPurchase = true; }
    return ({
        standardInfo: standardInfo,
        type: TypeActionOngoingPurchaseInfo.SelectStandard,
        updateInventoryAfterPurchase: updateInventoryAfterPurchase,
    });
};
export var actionOngoingPurchasePremiumDeselect = function () { return ({
    type: TypeActionOngoingPurchaseInfo.DeselectPremium,
}); };
export var actionOngoingPurchaseStandardDeselect = function () { return ({
    type: TypeActionOngoingPurchaseInfo.DeselectStandard,
}); };
export var actionOngoingPurchaseCloseAll = function () { return ({
    type: TypeActionOngoingPurchaseInfo.CloseAll,
}); };
export var actionOngoingPurchaseCharacterHelpSelect = function (characterHelpInfo) { return ({
    characterHelpInfo: characterHelpInfo,
    type: TypeActionOngoingPurchaseInfo.SelectCharacterHelp,
}); };
export var actionOngoingPurchaseCharacterHelpDeselect = function () { return ({
    type: TypeActionOngoingPurchaseInfo.DeselectCharacterHelp,
}); };
export var actionOngoingPurchaseCharacterHelpClose = function () { return ({
    type: TypeActionOngoingPurchaseInfo.CloseCharacterHelp,
}); };
export var actionOngoingPurchaseSkipProcessSelect = function (skipProcess) { return ({
    skipProcess: skipProcess,
    type: TypeActionOngoingPurchaseInfo.SelectSkipProcess,
}); };
export var actionOngoingPurchaseSkipProcessDeselect = function () { return ({
    type: TypeActionOngoingPurchaseInfo.DeselectSkipProcess,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/actionOngoingPurchase.ts
// module id = 38
// module chunks = 3